import { useEffect, useMemo } from 'react';
import { Rider, RiderQueryFilter } from '../../../shared/types';
import { usePageState } from '../../../Hooks/usePageState';
import { useOverviewLinkState } from '../linkstate/riderOverview.linkstate';
import { useGetRidersQuery } from '../../../GraphQL/hooks/useGetRidersQuery';

export const useSortedRiderQuery = () => {
    const { setLoading } = usePageState();
    const [state, setState] = useOverviewLinkState();
    const { page, pageSize, search, selectedDateRange, identityCheck, gender, signingMethod, timestamp } = state;

    const request = useMemo(
        () =>
            ({
                search: search ?? '',
                gender: gender != 'All' ? gender : '',
                signingMethod: signingMethod != 'All' ? signingMethod : '',
                identityCheck: identityCheck,
                dateRange: selectedDateRange,
                page: page ?? 1,
                limit: pageSize ?? 10,
            }) as RiderQueryFilter,
        [search, gender, selectedDateRange, identityCheck, signingMethod, page, pageSize]
    );

    useEffect(() => {
        refetch();
    }, [timestamp]);

    const { data: ridersPage, refetch, loading } = useGetRidersQuery(request);
    useEffect(() => setLoading(loading), [loading]);

    return {
        sortedRiders: ridersPage?.data ?? [],
        totalCount: ridersPage?.pagination.totalCount ?? 0,
        pageCount: ridersPage?.pagination.pageCount ?? 1,
        page: ridersPage?.pagination.page ?? 1,
        pageSize: pageSize,
        setPage: (newPage: number) => setState({ ...state, page: newPage }),
        setPageSize: (pageSize: number) => setState({ ...state, pageSize: pageSize }),
        refetch: () => refetch({ request }),
        loading,
    };
};
